// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

export type Order = 'ascending' | 'descending';
export type Unsubscribe = () => Promise<boolean>;
